import api from "@/shared/services/apiClient";
import type { InquiryFormData, IssueOption } from "@/features/inquiries/types/inquiry";

export const inquiryService = {
  searchInquiries: async (filters: any = {}, lang: string = "en") => {
    const cleanFilters: any = { lang };
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== "All") {
        cleanFilters[key] = value;
      }
    });
    const response = await api.get("/inquiry/search", { params: cleanFilters });
    return response.data;
  },

  createInquiry: async (formData: InquiryFormData) => {
    const { ticket_id, ...cleanData } = formData;
    const payload = {
      ...cleanData,
      occur_date: cleanData.occur_date ? cleanData.occur_date.replace(/\//g, "-") : null,
      watcher: cleanData.watcher || [],
    };
    const response = await api.post("/inquiry/create", payload);
    return response.data;
  },

  updateInquiry: async (ticketId: number, formData: Partial<InquiryFormData>) => {
    const { ticket_id, business_unit, ...cleanData } = formData;
    const payload = {
      ...cleanData,
      occur_date: cleanData.occur_date ? cleanData.occur_date.replace(/\//g, "-") : undefined,
      closed_dt: cleanData.closed_dt ? cleanData.closed_dt.replace(/\//g, "-") : null,
      watcher: cleanData.watcher || [],
    };
    const response = await api.put(`/inquiry/update/${ticketId}`, payload);
    return response.data;
  },

  deleteInquiry: async (ticketId: number) => {
    const response = await api.delete(`/inquiry/delete/${ticketId}`);
    return response.data;
  },

  getActiveIssues: async (lang: string = "en"): Promise<IssueOption[]> => {
    const response = await api.get("/inquiry/issues", { params: { lang } });
    return response.data;
  },

  getOfficersByBU: async (buId: string) => {
    try {
      const response = await api.get("/inquiry/getOfficersByBU", { params: { bu: buId } });
      const data = response.data;
      return Array.isArray(data) ? data : [data];
    } catch {
      return [];
    }
  },
};
